import axios from "axios";
import qs from "qs";
import { getLocalStorage } from "./auth";
import router from "@/router/index";
import { Message, Loading } from "element-ui";

// 定义 loading
let loading;

// loading开始 方法
function startLoading() {
  // element-ui loading 服务调用方式
  loading = Loading.service({
    lock: true,
    text: "拼命加载中",
    spinner: "el-icon-loading", // 自定义图标
    background: "rgba(0, 0, 0, 0.7)"
  });
}

// loading结束 方法
function endLoading() {
  loading.close();
}

// 定义一个变量，有请求变量加一，收到响应变量减一
let loadingCount = 0;

/**
 * 调用一次startLoadingAddCount() 方法 开启Loading 并 loadingCount + 1
 * 调用一次endLoadingSubCount() 方法 loadingCount - 1 直到为0 关闭loading
 */
export function startLoadingAddCount() {
  if (loadingCount === 0) {
    startLoading();
  }
  loadingCount++;
}

export function endLoadingSubCount() {
  loadingCount--;
  if (loadingCount === 0) {
    endLoading();
  }
}

if (process.env.NODE_ENV === "production") {
  // axios.defaults.baseURL = "http://ys.yunshangzg.com/yssj"; //测试环境
  axios.defaults.baseURL = "https://www.yunshangzg.com/yssj"; //线上环境
  // axios.defaults.baseURL = "https://47.98.243.167/hainan"; //线上环境
} else {
  // (axios.defaults.baseURL = "http://10.180.106.73:1008/yssj") //本地环境
  axios.defaults.baseURL = "https://www.yunshangzg.com/yssj";
  // (axios.defaults.baseURL = "https://www.yunshangzg.com/yssj")
  // axios.defaults.baseURL = "https://www.yunshangzg.com/yssj";
}
axios.defaults.timeout = 25000;
// axios.defaults.headers['Content-Type'] = 'application/json';
// axios.defaults.headers.post['Content-Type'] = 'application/json';
// axios.defaults.responseType = 'json'
//设置axios为form-data
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers.get["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.headers.delete["Content-Type"] =
  "application/json;charset=utf-8";

//interceptor拦截器
axios.interceptors.request.use(
  function (config) {
    // console.log(121221);
    const token = window.localStorage.getItem("token");
    if (token) {
      // console.log(token);
      config.headers.token = token;
      if (config.data) config.data.token = token;
      else if (config.params) config.params.token = token;
    }
    // 请求显示loading 效果
    //  startLoading();
    // config.data = qs.stringify(config.data) // 转为formdata数据格式
    return config;
  },
  function (err) {
    console.log(err);
    // endLoading()
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  function (response) {
    // endLoading()
    // console.log(response)
    var res = response.data;
    // console.log(res);
    // if (
    //   typeof res === "string" &&
    //   res.indexOf("code") > -1 &&
    //   res.indexOf("result") > -1
    // ) {
    //   res = JSON.parse(res);
    // }
    if (res) {
      if (res.code == 401) {
        // 用户token过期需要重新登录
        Message({
          message: "请重新登录",
          type: "info"
        });
        window.localStorage.clear();
        router.push("/login");
        return Promise.reject(res);
      }
      else {
        return Promise.resolve(res);
      }
    }
  },
  function (err) {
    // router.push("/wh");
    // console.log(err);
    // endLoading();
    return Promise.reject(res);
  }
);

function apiAxios(method, url, params, success, failure, type) {
  if (type == "formdata") {
    axios({
      method: method,
      url: url,
      data: method === "POST" || method === "PUT" ? qs.stringify(params) : null,
      params: method === "GET" || method === "DELETE" ? params : null,
      baseURL: root,
      withCredentials: false
    })
      .then(function (res) {
        if (res.data.success === true) {
          if (success) {
            success(res.data);
          }
        } else {
          if (failure) {
            failure(res.data);
          } else {
            console.log("error: " + JSON.stringify(res.data));
            // window.alert('error: ' + JSON.stringify(res.data))
          }
        }
      })
      .catch(function (err) {
        let res = err.response;
        if (err) {
          console.log("api error, HTTP CODE: " + err);
          // console.log('api error, HTTP CODE: ' + res.status)
          // window.alert('api error, HTTP CODE: ' + res.status)
        }
      });
  } else {
    if (params) {
      params = filterNull(params);
    }
    axios({
      method: method,
      url: url,
      data: method === "POST" || method === "PUT" ? params : null,
      params: method === "GET" || method === "DELETE" ? params : null,
      baseURL: root,
      withCredentials: false
    })
      .then(function (res) {
        if (res.data.success === true) {
          if (success) {
            success(res.data);
          }
        } else {
          if (failure) {
            failure(res.data);
          } else {
            // window.alert('error: ' + JSON.stringify(res.data))
            console.log("error: " + JSON.stringify(res.data));
          }
        }
      })
      .catch(function (err) {
        let res = err.response;
        if (err) {
          // window.alert('api error, HTTP CODE: ' + res.status)
          console.log("api error, HTTP CODE: " + err);
        }
      });
  }
}

export default axios;



//////////////////
// WEBPACK FOOTER
// ./src/utils/axios.js
// module id = cKc3
// module chunks = 41